import React, { useState } from "react";
import { Modal, TextField, Button, Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { notify } from "./Toast";
import { forgotPassword } from "../services/auth"; // You must define this function

const ForgotPasswordPopup = ({ open, onClose }) => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const validateEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleSubmit = async () => {
        if (!email) {
            setError("Email is required");
            return;
        }
        if (!validateEmail(email)) {
            setError("Invalid email format");
            return;
        }

        setError("");
        setLoading(true);

        try {
            const response = await forgotPassword({ email });
            if (response.success) {
                notify.success(response.message);
                onClose();
            } else {
                notify.error(response.message);
            }
        } catch (error) {
            notify.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose} disableScrollLock className="auth-modal"
            BackdropProps={{ style: { backgroundColor: "rgba(0, 0, 0, 0.8)" } }}
        >
            <Box sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "90%", sm: 400 },
                bgcolor: "#121212",
                boxShadow: 24,
                borderRadius: 2,
                p: 4,
                color: "#fff",
            }}>
                <Typography variant="h6" gutterBottom>
                    Forgot Password
                </Typography>
                <TextField
                    fullWidth
                    label="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={!!error}
                    helperText={error}
                    variant="outlined"
                    margin="normal"
                    InputLabelProps={{ style: { color: "#aaa" } }}
                    InputProps={{ style: { backgroundColor: "#1e1e1e", borderRadius: "8px", border: "1px solid #333", color: "#fff" } }}
                />
                <Button
                    fullWidth
                    variant="contained"
                    sx={{
                        mt: 2, backgroundColor: "#00ffff", color: "#000",
                        '&.Mui-disabled': {
                            backgroundColor: "#00ffff",  // Keep background even when disabled
                            color: "#000",
                            mt: 2
                        },
                    }}
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" /> : "Sent Reset Link"}
                </Button>
            </Box>
        </Modal>
    );
};

export default ForgotPasswordPopup;
